import React, { useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSnackbar } from "notistack";
import classNames from "classnames";

import IntervalBarCmp from "components/IntervalBar/IntervalBarCmp";
import ChartsCmp from "./ChartsCmp";
//import Tables from "./Tables";
import styles from "./_charts.module.scss";

import {
	getTodayDataMany, getWeeklyDataMany, getMonthlyDataMany, getCustomDataMany,
	useGetDevices,
} from "service/AgrismartService";
import { getErrorMessage } from "service/Client";


export default function IntervalPageCmp({type, display}) {

	const [cmpSize, setCmpSize] = useState()
	const [deviceSel, setDeviceSel] = useState();
	const [interval, setInterval] = useState("daily");
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const { enqueueSnackbar } = useSnackbar();
	let { devices } = useGetDevices();

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" });
	}


	let { data } = useQuery(['agrismartData', { deviceSel, interval, startDate, endDate }], () => {
		const exactTime = true
		let promise
		if (interval === "daily") {
			promise = getTodayDataMany(deviceSel, exactTime)
		} else if (interval === "weekly") {
			promise = getWeeklyDataMany(deviceSel, exactTime)
		} else if (interval === "monthly") {
			promise = getMonthlyDataMany(deviceSel, exactTime)
		} else if (startDate !== null && endDate !== null) {
			promise = getCustomDataMany(deviceSel, startDate, endDate, exactTime)
		}
		return promise
	}, {
		// per fare partire la query richiedo che almeno un id sia non nullo
		enabled: !!deviceSel && deviceSel.reduce((a, d) => a || !!d, false) && (interval !== 'custom' || (!!startDate && !!endDate)),
		initialData: [],
		onError: showError,
		refetchInterval: (interval === 'daily') ? 10000 : false,
	})


	// funzione filtro per raggruppare i dispositivi per tipo RIF/A/B
	const filterDevicesRifAB = (idx, d) => {
		switch (idx) {
			case 0: return d.type === 1	// RIF
			case 1: return d.type === 2	// A
			case 2: return d.type === 3	// B
			default: return true
		}
	}
	
	// module initialization
	useEffect(() => {
		let initialDeviceSel
		if (type == 'microclimate') {
			setCmpSize(3)
			initialDeviceSel = new Array(3).fill(null)
			initialDeviceSel[0] = devices.filter(d => filterDevicesRifAB(0, d))[0]?.device
			initialDeviceSel[1] = devices.filter(d => filterDevicesRifAB(1, d))[0]?.device
			initialDeviceSel[2] = devices.filter(d => filterDevicesRifAB(2, d))[0]?.device
			setDeviceSel(initialDeviceSel)
		} else {
			setCmpSize(2)
			initialDeviceSel = new Array(2).fill(null)
			initialDeviceSel[0] = devices[0]?.device
			initialDeviceSel[1] = devices[1]?.device
			setDeviceSel(initialDeviceSel)
		}
	}, [type, devices])


	if (devices.length < 2) return <div>Questa sezione richiede almeno 2 dispositivi</div>
	if (!cmpSize) return null

	return (
		<div className={classNames("animated", "fadeIn", styles.box)}>
			<IntervalBarCmp
				cmpSize={cmpSize}
				devices={devices}
				deviceSel={deviceSel}
				setDeviceSel={setDeviceSel}
				interval={interval}
				setInterval={setInterval}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
				showForecastBtn={false}
				type={type}
				filterDevicesRifAB={filterDevicesRifAB}
			/>

			{
				display === "charts" &&	<ChartsCmp cmpSize={cmpSize} data={data} type={type} />
			}
			{/*
				display === "table" && <Tables data={data} type={type} />
			*/}
		</div>
	);
}
